import React from 'react';
import { theme } from '@fiverr-private/theme';
import { useWindowSize } from '../../hooks/useWindowSize';
import { SellerRepresentative } from '../../constants/seller';
import { renderGigByExperience } from '../../GigCardListings/utils/gigByExperience';
import { EntriesBasePropTypes } from '../../GigCardListings/types/types';
import { GigCardType } from '../../GigCards/types';
import AgencyV2Card from '../../GigCards/ModernGigCards/AgencyV2Card';

export const RenderGigForGigCardListings = (props) => {
    const { isExperiential, isNonExperiential, type, seller } = props;
    const { width } = useWindowSize();
    const relevantScreenSizeForAgencyCard = width < theme.numericBreakpoints.sm || width >= theme.numericBreakpoints.lg;

    if (type === 'agency' && seller.type === SellerRepresentative.AGENCY && relevantScreenSizeForAgencyCard) {
        return <AgencyV2Card {...props} />;
    }

    return renderGigByExperience(isNonExperiential, isExperiential)(props);
};

RenderGigForGigCardListings.propTypes = {
    ...GigCardType,
    ...EntriesBasePropTypes,
};
